import React from "react";
import whatsAppLog from "../../assets/whatsAppLogo.png";

const FloatingWhatsApp = () => {
  const phoneNumber = "918121877077"; // Updated number
  const message = "Hello! I would like to chat with you.";
  const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
    message
  )}`;

  return (
    <a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        position: "fixed",
        bottom: "40px",
        right: "40px",
        zIndex: 1000,
        backgroundColor: "#25D366",
        borderRadius: "50%",
        width: "60px",
        height: "60px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
        textDecoration: "none",
      }}
    >
      <img
        src={whatsAppLog}
        // src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTaB2Vp8D2N1asDqBJLcpz2Dr3rSM_iOIAGoQ&s"
        alt="Chat on WhatsApp"
        style={{ width: "60px", height: "60px" }}
      />
    </a>
  );
};

export default FloatingWhatsApp;
